import { Timestamp } from "tsproto/google/protobuf/timestamp";
function eventComparator(a, b) {
    const da = Timestamp.toDate(a.startDate);
    const db = Timestamp.toDate(b.startDate);
    if (da === db)
        return 0;
    if (da > db)
        return 1;
    return -1;
}
function mainEventComparator(a, b) {
    const da = Timestamp.toDate(a.event.startDate);
    const db = Timestamp.toDate(b.event.startDate);
    if (da === db)
        return 0;
    if (da > db)
        return 1;
    return -1;
}
// Sort main events in place from earliest start time to latest start time in place
function sortMainEvents(mainEvents) {
    mainEvents.sort(mainEventComparator);
    return mainEvents;
}
// Sort events in place from earliest start time to latest start time in place
function sortEvents(events) {
    events.sort(eventComparator);
    return events;
}
function futureMainEvents(mainEvents, date) {
    if (!date) {
        date = new Date();
    }
    return mainEvents.filter(me => Timestamp.toDate(me.event.startDate) > date);
}
function getEventsOfType(mainEvent, eventType) {
    const events = [];
    for (const option of mainEvent?.options) {
        const evts = option.events.filter(e => e.eventType === eventType);
        evts.forEach(e => events.push(e));
    }
    return events;
}
function stripAddress(text) {
    // Check for null, undefined, or empty strings
    if (!text || text.trim().length === 0) {
        return text;
    }
    // Regular expression to match common US address formats at the end of a string.
    // This regex looks for:
    // - A space or the start of the string.
    // - A street number.
    // - A street name (non-greedy).
    // - A street type (St., Ave., etc.) followed by a word boundary.
    // - Any characters following the street type until the end of the string
    //   (to capture unit, city, state, zip, etc.).
    const addressRegex = /(?:^|\s+)\d{1,5}\s+.+?\s+(?:Avenue|Ave|Circle|Ct|Court|Dr|Drive|Lane|Ln|Parkway|Pkwy|Place|Pl|Road|Rd|Square|Sq|Street|St|Terrace|Ter)\b.*$/i;
    // Replace the matched address part with an empty string and trim any resulting whitespace.
    return text.replace(addressRegex, "").trim();
}
const CalendarEventComparator = (eventA, eventB) => {
    const aStartDate = Timestamp.toDate(eventA.startTime);
    const bStartDate = Timestamp.toDate(eventB.startTime);
    const dtStartMs = aStartDate.getTime() - bStartDate.getTime();
    if (dtStartMs === 0) {
        const aEndDate = Timestamp.toDate(eventA.endTime);
        const bEndDate = Timestamp.toDate(eventB.endTime);
        return aEndDate.getTime() - bEndDate.getTime();
    }
    return dtStartMs;
};
export { futureMainEvents, sortEvents, sortMainEvents, getEventsOfType, stripAddress, CalendarEventComparator };
